import imageCompression from 'browser-image-compression';

export default function handleImageUpload(img, uploadToServer) {

    var imageFile = base64ToBlob(img.replace(/^data:image\/(png|jpg);base64,/, ""), 'image/jpg');
    //console.log('originalFile instanceof Blob', imageFile instanceof Blob); // true
    //console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`);

    var maxSizeMB = 1;
    var maxWidthOrHeight = 1000; // compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight
    imageCompression(imageFile, maxSizeMB, maxWidthOrHeight) // maxSizeMB, maxWidthOrHeight are optional
        .then(function (compressedFile) {
            //console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
            //console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB


            var reader = new FileReader();
            var base64data;
            reader.readAsDataURL(compressedFile);
            reader.onloadend = function() {
                base64data = reader.result;
                uploadToServer(base64data); // write your own logic
            }
        })
        .catch(function (error) {
            console.log(error.message);
        });


    function base64ToBlob(base64, mime)
    {
        mime = mime || '';
        var sliceSize = 1024;
        var byteChars = window.atob(base64);
        var byteArrays = [];

        for (var offset = 0, len = byteChars.length; offset < len; offset += sliceSize) {
            var slice = byteChars.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, {type: mime});
    }
}


// WEBPACK FOOTER //
// ./src/functions/handleImageUpload.js